export function getDefaultOptions(options) {

  if (options !== void 0 && options.length > 0) {
    return [...options];
  }

  return ['Sample option #1', 'Sample option #1'];

}

export function filterEmptyOptions(options) {

  const nonEmptyOptions = [];

  for (let option of options) {

    if (option.trim() === '') {
      continue;
    }

    nonEmptyOptions.push(option);

  }

  return nonEmptyOptions;

}